import {
    SAVE_ASSESSMENT,
    DELETE_ASSESSMENT,
    EDIT_ASSESSMENT,
    GET_ASSESSMENTS,
    CREATE_ASSESSMENT,
    GET_ASSESSMENT_BY_ID,
} from './assessment.types';

/** Assessments */

export const getAssessments = (clientId, params, load) => {
    return {
        type: GET_ASSESSMENTS,
        payload: { clientId, params, load },
    };
};
export const getAssessmentBiId = (assessmentId) => {
    return {
        type: GET_ASSESSMENT_BY_ID,
        payload: { assessmentId },
    };
};

export const createAssessment = (clientId) => {
    return {
        type: CREATE_ASSESSMENT,
        payload: { clientId },
    };
};

export const saveAssessment = (clientId, reqParams) => {
    return {
        type: SAVE_ASSESSMENT,
        payload: { clientId, reqParams },
    };
};

export const editAssessment = (id, body) => {
    return {
        type: EDIT_ASSESSMENT,
        payload: { id, body },
    };
};

export const deleteAssessment = (id, module, requestParams) => {
    return {
        type: DELETE_ASSESSMENT,
        payload: { id, module, requestParams },
    };
};

/** End */
